/**
 * Logs the user out, then lands on the logged-out state (`/?loggedout=1`) rather than
 * `/auth/login`. Going to `/auth/login` would immediately restart the Microsoft OIDC flow
 * in production — the "logout bounce". From the logged-out state the user re-authenticates
 * deliberately via the login page's button.
 *
 * `navigate` is injectable for tests; it defaults to a real browser navigation.
 */
export async function logout(navigate: (url: string) => void = (url) => window.location.assign(url)): Promise<void> {
  await fetch('/auth/logout', {
    method: 'POST',
    credentials: 'include',
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
  });
  navigate('/?loggedout=1');
}
